import { useSelector } from "react-redux";
import { useTranslation } from "../../../hooks/useTranslation";
import "./NoDataComponent.scss";

export const NoDataComponent = ({ children }) => {
  const { skin } = useSelector((state) => state.header);
  const { noDataComponent } = useTranslation()?.cabinet?.orders;

  return (
    <div className="nodata">
      <img width={78} height={75} src={`/img/ui/empty-folder--${skin}.svg`} alt="empty folder" />
      <div className="nodata__cotainer">{noDataComponent}</div>
      {children && <div className="nodata__actions">{children}</div>}
    </div>
  );
};
